import React, { useEffect, useMemo, useState, useLayoutEffect } from "react";
import { createPortal } from "react-dom";
import web from "../../assets/halloween/net.svg";

export function HalloweenNet({ anchorId }) {
    const container = useMemo(() => {
        if (typeof document === "undefined") return null;
        const el = document.createElement("div");
        el.setAttribute("data-holiday-overlay", "halloween");
        el.style.position = "absolute";
        el.style.pointerEvents = "none";
        el.style.zIndex = "2"; // поверх контента формы
        return el;
    }, []);

    const [anchor, setAnchor] = useState(null);

    useEffect(() => {
        if (typeof document === "undefined") return;
        const tryFind = () => setAnchor(document.getElementById(anchorId));
        tryFind();
        const mo = new MutationObserver(tryFind);
        mo.observe(document.documentElement, { childList: true, subtree: true });
        return () => mo.disconnect();
    }, [anchorId]);

    useEffect(() => {
        if (!anchor || !container) return;
        anchor.appendChild(container);
        return () => {
            try { container.remove(); } catch {}
        };
    }, [anchor, container]);

    const OFFSET_X =  -1;
    const OFFSET_Y =  -2;
    const WIDTH    =  64;
    const HEIGHT   =  64;

    useLayoutEffect(() => {
        if (!container) return;
        container.style.top = `${OFFSET_Y}px`;
        container.style.right = `${OFFSET_X}px`;
        container.style.left = "auto";           // на всякий случай
        container.style.bottom = "auto";
        container.style.width = `${WIDTH}px`;
        container.style.height = `${HEIGHT}px`;
    }, [container , OFFSET_X, OFFSET_Y]);

    if (!container || !anchor) return null;

    return createPortal(
        <img
            src={web}
            alt=""
            width={WIDTH}
            height={HEIGHT}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
            aria-hidden="true"
        />,
        container
    );
}
